import { render, staticRenderFns } from "./agoda.vue?vue&type=template&id=f4900320&scoped=true&"
import script from "./agoda.vue?vue&type=script&lang=js&"
export * from "./agoda.vue?vue&type=script&lang=js&"
import style0 from "./agoda.vue?vue&type=style&index=0&id=f4900320&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4900320",
  null
  
)

export default component.exports